import { render, staticRenderFns } from "./ProjectStatuses.vue?vue&type=template&id=2ec3be82&scoped=true&"
import script from "./ProjectStatuses.vue?vue&type=script&lang=ts&"
export * from "./ProjectStatuses.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectStatuses.vue?vue&type=style&index=0&id=2ec3be82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3be82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBadge,VChip})
